import { auth, db } from '../../config/firebase';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
//import { createUserWithEmailAndPassword, updateProfile, signOut, signInWithEmailAndPassword } from 'firebase/auth'

import { createUserWithEmailAndPassword, signOut, signInWithEmailAndPassword } from 'firebase/auth'


const register = async (email, parola) => {
    const userResponse = await createUserWithEmailAndPassword(auth, email, parola)
    /*
    await updateProfile({
        displayName: "displayName",
        photoURL: "displayName"
    })
    */
    if (userResponse.user) {
        localStorage.setItem('user', JSON.stringify(userResponse.user))
    }
    return userResponse.user
}

const logout = async () => {
    await signOut(auth);
    localStorage.removeItem('user');
}

const login = async (email, parola) => {
    const userResponse = await signInWithEmailAndPassword(auth, email, parola)
    if (userResponse.user) {
        localStorage.setItem('user', JSON.stringify(userResponse.user))
    }
    return userResponse.user
}

const loginotp = async (user) => {
    if (user) {
        localStorage.setItem('user', JSON.stringify(user))
    }
    return user
}

const checkAdminAccess = async (userId) => {
    if (!userId) {
        return false;
    }
    const adminUsersRef = collection(db, 'adminusers');
    const adminQuery = query(adminUsersRef, where('userId', '==', userId), limit(1));
    const snapshot = await getDocs(adminQuery);
    return !snapshot.empty;
};

const authService = {
    register,
    logout,
    login,
    loginotp,
    checkAdminAccess,
}

export default authService
